import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

// Custom hook to get WhatsApp settings
export const useWhatsAppSettings = () => {
  const [settings, setSettings] = useState({
    whatsappNumber: '+919876543210',
    whatsappMessage: "Hello, I'm interested in your properties",
    whatsappEnabled: true,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/settings/website-settings`);
        const data = await response.json();
        if (data.success && data.data) {
          setSettings(data.data);
        }
      } catch (error) {
        console.error('Failed to fetch WhatsApp settings:', error);
        // Keep default settings on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};

// Helper function to generate WhatsApp link
export const generateWhatsAppLink = (whatsappNumber, message = '') => {
  const cleanNumber = whatsappNumber.replace(/\+/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${cleanNumber}&text=${encodedMessage}`;
};
